import {css} from 'lit';

export const attributeWidget = css`
	.indicator {
		width: 20px;
		color: var(--color-warn);
	}
	.satisfied .indicator {
		color: var(--color-ok);
	}
	.title {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font: var(--font-widget-title);
		color: var(--color-widget-text);
		margin-bottom: 12px;
		gap: 4px;
	}
	.tools {
		display: flex;
		flex-direction: row;
		gap: 8px;
		margin-left: auto;
	}
	.tools_button {
		color: var(--color-widget-infoicon);
		background-color: transparent;
		cursor: pointer;
		transition: background-color 0.4s, color 0.4s;
		border: none;
		padding: 0;
	}

	.status {
		display: flex;
		flex-direction: row;
	}
	.status .reset {
		display: none;
	}
	.satisfied .status:hover .reset {
		display: block;
	}
	.satisfied .status:hover .indicator {
		display: none;
	}
	.indicator {
		width: 16px;
	}
	.icon {
		display: flex;
		align-items: center;
	}
	.icon svg path {
		stroke: currentColor;
	}
	.icon svg circle {
		stroke: currentColor;
	}

	.values {
		display: flex;
		flex-flow: wrap;
	}
	.numericInput {
		display: block;
		font: var(--font-widget-label);
		font-size: var(--font-size-widget);
		color: var(--color-white);
		background-color: var(--color-background-widget);
		border: 1px solid var(--color-widget-border);
		height: var(--height-widget);
		padding: 0 var(--very-small-padding);
		width: 100%;
		text-align: left;
		outline: none;
	}
`;
